/**
 * 获取当前日期字符串
 * @description 获取当前日期的格式化字符串，用于文件名
 * @returns {string} 格式化的日期字符串，格式为 YYYYMMDD_HHmmss
 * @example
 * const dateStr = getCurrentDateString();
 * console.log(dateStr); // 输出：20260327_143052
 */
function getCurrentDateString(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  
  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
}

/**
 * @doc true
 * @description 将 JSON 字符串下载为文件
 * @param {string} str - 要下载的文件内容（通常是 JSON 字符串）
 * @returns {void}
 * @example
 * const jsonData = JSON.stringify({ name: 'test', value: 123 });
 * PRL.project_json_str2filedownload(jsonData);
 * // 会下载文件：shuchk_20260327_143052.shuchk
 */
export function project_json_str2filedownload(str: string): void {
  const blob = new Blob([str], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `shuchk_${getCurrentDateString()}.shuchk`;
  a.click();
  URL.revokeObjectURL(url);
}
